











































import { Vue, Component, Prop } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ErrorDisplay from '@/components/ErrorDisplay.vue'

@Component({
    computed: {

    },
    components: {
        'font-awesome-icon': FontAwesomeIcon,
        ErrorDisplay
    }
})

export default class CapacitesPhaseSuivante extends Vue {
    @Prop() showPopup?: boolean


    // Ferme la popup
    cancel () {
        this.$emit('cancel')
    }

}
